<template>
  <section class="third-parties" data-nosnippet>
    <div class="third-parties__content">
      <h5>
        List of Third Parties to which {{ $store.state.brand.name }} Sells, or
        with which {{ $store.state.brand.name }} shares, Personal Information
        Containing Telephone Numbers for Contacting Consumers by Voice or
        Texting
      </h5>
      <div class="q-my-lg"><p>Last Updated: January 3, 2025</p></div>
      <h6>Automotive Manufacturers, Franchise Dealers and Agencies</h6>
      <p class="q-py-sm">Alfa Romeo</p>
      <ul type="disc">
        <li>Sanctus, LLC (dba Shift Digital) (Agency)</li>
        <li>Alfa Romeo Franchise Dealers</li>
      </ul>
      <p class="q-py-sm">Audi of America, Inc.</p>
      <ul type="disc">
        <li>Audi Franchise Dealers</li>
      </ul>
      <p class="q-py-sm">BMW of North America, Inc.</p>
      <ul type="disc">
        <li>Autodata Solutions Group (Agency)</li>
        <li>BMW Franchise Dealers</li>
        <li>Mini Franchise Dealers</li>
      </ul>
      <p class="q-py-sm">Ford Motor Company</p>
      <ul type="disc">
        <li>FordDirect (Agency)</li>
        <li>Ford Franchise Dealers</li>
        <li>Lincoln Franchise Dealers</li>
      </ul>
      <p class="q-py-sm">General Motors Corporation</p>
      <ul type="disc">
        <li>Dentsu International/Carat USA, Inc. (Agency)</li>
        <li>Buick Franchise Dealers</li>
        <li>Cadillac Franchise Dealers</li>
        <li>Chevrolet Franchise Dealers</li>
        <li>GMC Franchise Dealers</li>
      </ul>
      <p class="q-py-sm">American Honda Motor Co., Inc.</p>
      <ul type="disc">
        <li>Urban Science Applications, Inc. (Agency)</li>
        <li>Honda Franchise Dealers</li>
        <li>Acura Franchise Dealers</li>
      </ul>
      <p class="q-py-sm">Hyundai Motor America, Inc.</p>
      <ul type="disc">
        <li>Autodata Solutions Group (Agency)</li>
        <li>Hyundai Franchise Dealers</li>
        <li>Genesis Franchise Dealers</li>
      </ul>
      <p class="q-py-sm">Kia Motors America, Inc.</p>
      <ul type="disc">
        <li>Sanctus, LLC (dba Shift Digital) (Agency)</li>
        <li>Kia Franchise Dealers</li>
      </ul>
      <p class="q-py-sm">Mazda Motor of America, Inc.</p>
      <ul type="disc">
        <li>Mazda Franchise Dealers</li>
      </ul>
      <p class="q-py-sm">Mercedes Benz USA LLC</p>
      <ul type="disc">
        <li>Accelerated Marketing Partners (Agency)</li>
        <li>Mercedes Benz Franchise Dealers</li>
      </ul>
      <p class="q-py-sm">Mitsubishi Motors North America, Inc.</p>
      <ul type="disc">
        <li>Unite Digital (Agency)</li>
        <li>Mitsubishi Franchise Dealers</li>
      </ul>
      <p class="q-py-sm">Nissan North America, Inc.</p>
      <ul type="disc">
        <li>Sanctus, LLC (dba Shift Digital) (Agency)</li>
        <li>Infiniti Franchise Dealers</li>
        <li>Nissan Franchise Dealers</li>
      </ul>
      <p class="q-py-sm">Renault-Nissan-Mitsubishi Alliance</p>
      <ul type="disc">
        <li>Renault Franchise Dealers</li>
      </ul>
      <p class="q-py-sm">Subaru of North America, Inc.</p>
      <ul type="disc">
        <li>Urban Science Applications, Inc. (Agency)</li>
        <li>Subaru Franchise Dealers</li>
      </ul>
      <p class="q-py-sm">Stellantis N.V.</p>
      <ul type="disc">
        <li>Sanctus, LLC (dba Shift Digital) (Agency)</li>
        <li>Autodata Solutions Group (Agency for Maserati)</li>
        <li>Alfa Romeo Franchise Dealers</li>
        <li>Chrysler Franchise Dealers</li>
        <li>Dodge Franchise Dealers</li>
        <li>Fiat Franchise Dealers</li>
        <li>Jeep Franchise Dealers</li>
        <li>Maserati Franchise Dealers</li>
        <li>Ram Franchise Dealers</li>
      </ul>
      <p class="q-py-sm">Jaguar Land Rover North America, LLC (Tata Motors)</p>
      <ul type="disc">
        <li>Land Rover Franchise Dealers</li>
        <li>Jaguar Franchise Dealers</li>
      </ul>
      <p class="q-py-sm">Toyota Motor Sales U.S.A, Inc.</p>
      <ul type="disc">
        <li>Autodata Solutions Group</li>
        <li>Toyota Franchise Dealers</li>
        <li>Lexus Franchise Dealers</li>
      </ul>
      <p class="q-py-sm">Volkswagen of America, Inc.</p>
      <ul type="disc">
        <li>Volkswagen Franchise Dealers</li>
        <li>Porsche Cars North America, Inc.</li>
        <li>Porsche Franchise Dealers</li>
      </ul>
      <p class="q-py-sm">
        Volvo Cars of North America, Inc. (Zhejiang Geely Holding Group)
      </p>
      <ul type="disc">
        <li>Urban Science Applications, Inc. (Agency)</li>
        <li>Volvo Franchise Dealers</li>
      </ul>
      <h6>Independent Non-Franchised Used Vehicle Dealers</h6>
      <ul type="disc">
        <li>CarMax</li>
        <li>
          Independent, non-franchised used vehicle dealers that are selected by
          the consumer based on used vehicle inventories displayed to the
          consumer.
        </li>
      </ul>
      <h6>Third Party Lead Buyers (Wholesale)</h6>
      <ul type="disc">
        <li>AutoWeb, Inc.</li>
        <li>Cars.com, LLC</li>
        <li>Detroit Trading Company, Inc.</li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  name: "ThirdParties",
  /*metaInfo: {
    titleTemplate: "%s | Terms of Service"
  },*/
  mounted() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }
};
</script>

<style scoped lang="scss">
.third-parties {
  .third-parties__content {
    max-width: 1200px;
    margin: 0 auto;
    padding: $space-xl $space-lg;

    @include screen-md {
      padding: $space-xl $space-md;
    }
  }

  h1,
  h2,
  h5,
  h4,
  h5,
  h6 {
    margin: 1em 0;
  }

  ul {
    margin: 0 0 0 $space-lg;
    padding: 0;
    text-indent: 0;
  }

  li {
    padding-bottom: $space-xs;
  }
}
</style>
